import React from "react";
import PT from "prop-types";
import styled from "styled-components";

import { editorjs } from "./editorjs_vars";
import { ScrollAnim } from "~/src/components";

const EditorParagraph = ({ text, ...props }) => {
    return (
        <ScrollAnim type="slideInDownSmall" delay={0}>
            <SEditorParagraph {...props}>{text}</SEditorParagraph>
        </ScrollAnim>
    );
};

EditorParagraph.propTypes = {
    text: PT.string,
};

const SEditorParagraph = styled.p`
    padding: ${editorjs.block_padding};
    margin-bottom: 0;
`;

export default EditorParagraph;
